import { IconMail, IconMessage, IconPhoneCall } from "@tabler/icons-react";
import AppContext from "Context/appContext";
import Card from "components/Card";
import FormInput from "components/FormInput";
import "containers/ContactDetails";
import "containers/ContactDetails/index.css";
import { useContext, useEffect, useState, useCallback } from "react";
import { Controller, useFormState } from "react-hook-form";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import UrlServices from "../../services/Url";

const ContactDeatils = () => {
  const {
    formdata,
    setFormData,
    productCartDetail,
    progressState,
    setErrors,
    reactHookFormData,
    countryDetails,
    isWebView,
    setNotificationWay,
    isButtonClicked,
    userSettings,
    bookingList,
    selectedStoreDetails,
    encryptionKey,
    emailVerificationId,
    setEmailVerificationId,
    setEmailVerificationToken,
    isEmailVerified,
    setIsEmailVerified,
    emailVerificationPending,
    setEmailVerificationPending,
    emailVerificationError,
    setEmailVerificationError
  } = useContext(AppContext);

  const { register, handleSubmit, watch, control, formErrors } =
    reactHookFormData;
  const [menuOption, setMenuOption] = useState([
    {
      id: 1,
      name: "SMS Text (Instant)",
      icon: <IconMessage className="quote-contact-icon" />,
      value: "sms",
      active: false,
    },
    {
      id: 2,
      name: "Email (Instant)",
      icon: <IconMail className="quote-contact-icon" />,
      value: "email",
      active: false,
    },
    {
      id: 3,
      name: "Phone",
      icon: <IconPhoneCall className="quote-contact-icon" />,
      value: "phone",
      active: false,
    },
  ]);
  const [verificationCode, setVerificationCode] = useState("");

  const apiBaseUrl = process.env.REACT_APP_APPOINTMENT_PRO_API_URL;


  // Get the current form errors from useFormState
  const { errors } = useFormState({ control: control });

  const updateStatus = (index) => {
    const selectedItem = menuOption[index];
    
    // Prevent selection if phone option is disabled
    if (selectedItem.value === 'phone' &&
      (countryDetails?.country !== "Australia" &&
        countryDetails?.country !== "United States" &&
        countryDetails?.country !== "Canada")) {
      return;
    }
    
    menuOption.filter((m) => {
      if (m.id === selectedItem.id) {
        m.active = true;
      } else {
        m.active = false;
      }
    });
    
    const optionValue = selectedItem.active ? selectedItem.value : "";
    setFormData({
      ...formdata,
      option: optionValue,
    });
    
    // Update react-hook-form value for option field
    reactHookFormData.setValue("option", optionValue);
    
    // Trigger validation when any card option is clicked
    if (reactHookFormData.trigger) {
      reactHookFormData.trigger();
    }
  };

  const updateFields = (index) => {
    // Update checkbox state immediately, before validation
    const selectedItem = menuOption[index];

    // Prevent selection if phone option is disabled
    if (selectedItem.value === 'phone' &&
      (countryDetails?.country !== "Australia" &&
        countryDetails?.country !== "United States" &&
        countryDetails?.country !== "Canada")) {
      return;
    }

    // Create a new array to update the checkbox state
    const updatedMenuOption = menuOption.map((m, idx) => ({
      ...m,
      active: idx === index, // Set active to true only for the clicked item
    }));

    // Filter out any non-serializable data (like React components) before storing
    const serializableMenuOption = updatedMenuOption.map(
      ({ id, name, value, active }) => ({
        id,
        name,
        value,
        active, // Only keep serializable data
      })
    );

    // Save the serializable version of the state in localStorage
    sessionStorage.setItem(
      "menuOption",
      JSON.stringify(serializableMenuOption)
    );

    // Update the checkbox state first
    setMenuOption(updatedMenuOption);

    // Update the form data to reflect the selected option
    setFormData({
      ...formdata,
      option: selectedItem.value,
    });
    
    // Update react-hook-form value for option field
    reactHookFormData.setValue("option", selectedItem.value);

    setNotificationWay(selectedItem.value);

    // No validation triggered here; it's deferred to the button click event

    // Now trigger validation (this will show errors, but not stop checkbox update)
    // handleSubmit(() => {
    //   // Validation logic here
    //   console.log("Validation passed");
    // })(); // Immediately invoke handleSubmit to trigger validation
  };

  // Retry helper: retries fetch on network/5xx errors up to maxRetries times
  const fetchWithRetry = useCallback(async (url, options, maxRetries = 2) => {
    let lastError;
    for (let attempt = 0; attempt <= maxRetries; attempt++) {
      try {
        const response = await fetch(url, options);
        // Retry on 5xx server errors (not on 4xx client errors)
        if (response.status >= 500 && attempt < maxRetries) {
          await new Promise((r) => setTimeout(r, 1000 * (attempt + 1)));
          continue;
        }
        return response;
      } catch (error) {
        lastError = error;
        if (attempt < maxRetries) {
          await new Promise((r) => setTimeout(r, 1000 * (attempt + 1)));
        }
      }
    }
    throw lastError;
  }, []);

  const handleSendVerificationCode = useCallback(async () => {
    setEmailVerificationError("");
    setEmailVerificationToken(null);
    setIsEmailVerified(false);

    if (reactHookFormData?.trigger) {
      await reactHookFormData.trigger("email");
    }
    if (!formdata.email || errors?.email) {
      setEmailVerificationError("Enter a valid email address to verify.");
      return;
    }

    setEmailVerificationPending(true);
    try {
      const response = await fetchWithRetry(
        `${apiBaseUrl}/${UrlServices.sendEmailVerification}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            q_: encryptionKey,
            email: formdata.email,
            customer_name: `${formdata.firstName || ""} ${formdata.lastName || ""}`.trim(),
            store_id: selectedStoreDetails?.store_id || "",
          }),
        }
      );
      const data = await response.json();
      if (!response.ok) {
        setEmailVerificationError(
          data?.message || "Unable to send verification code."
        );
        return;
      }
      setEmailVerificationId(data?.verification_id || null);
    } catch (error) {
      setEmailVerificationError("Unable to send verification code. Please try again.");
    } finally {
      setEmailVerificationPending(false);
    }
  }, [
    apiBaseUrl,
    encryptionKey,
    errors?.email,
    fetchWithRetry,
    formdata.email,
    formdata.firstName,
    formdata.lastName,
    reactHookFormData,
    selectedStoreDetails?.store_id,
    setEmailVerificationError,
    setEmailVerificationId,
    setEmailVerificationPending,
    setEmailVerificationToken,
    setIsEmailVerified,
  ]);

  const handleVerifyCode = useCallback(async () => {
    setEmailVerificationError("");

    if (!verificationCode) {
      setEmailVerificationError("Enter the verification code.");
      return;
    }
    if (!emailVerificationId) {
      setEmailVerificationError("Please request a verification code first.");
      return;
    }

    setEmailVerificationPending(true);
    try {
      const response = await fetchWithRetry(
        `${apiBaseUrl}/${UrlServices.verifyEmailVerification}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            q_: encryptionKey,
            email: formdata.email,
            code: verificationCode,
            verification_id: emailVerificationId,
          }),
        }
      );
      const data = await response.json();
      if (!response.ok) {
        setEmailVerificationError(
          data?.message || "Verification failed. Please try again."
        );
        return;
      }
      setEmailVerificationToken(data?.verification_token || null);
      setIsEmailVerified(true);
      setEmailVerificationError("");
    } catch (error) {
      setEmailVerificationError("Verification failed. Please try again.");
    } finally {
      setEmailVerificationPending(false);
    }
  }, [
    apiBaseUrl,
    emailVerificationId,
    encryptionKey,
    fetchWithRetry,
    formdata.email,
    setEmailVerificationError,
    setEmailVerificationPending,
    setEmailVerificationToken,
    setIsEmailVerified,
    verificationCode,
  ]);

  // Manually add the `icon` back if needed after loading from storage
  const restoreOptionField = () => {
    const storedMenuOption = sessionStorage.getItem("menuOption");
    if (storedMenuOption) {
      const parsedMenuOption = JSON.parse(storedMenuOption);
      const updatedMenuOption = parsedMenuOption.map((option) => ({
        ...option,
        icon: (() => {
          switch (option.value) {
            case "sms":
              return <IconMessage className="quote-contact-icon" />;
            case "email":
              return <IconMail className="quote-contact-icon" />;
            default:
              return <IconPhoneCall className="quote-contact-icon" />;
          }
        })(),
      }));
      setMenuOption(updatedMenuOption); // Restore state from sessionStorage
    }
  };

  // Detect web view on component mount
  useEffect(() => {
    // handleSubmit(() => {})(); // Immediately invoke handleSubmit to trigger validation

    // Only restore state when the component mounts (i.e., on tab reopen)
    restoreOptionField();

    const handleBeforeUnload = () => {
      sessionStorage.removeItem("menuOption"); // Clear only when the tab is closed or refreshed
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      // Optionally clear sessionStorage on component unmount
      window.removeEventListener("beforeunload", handleBeforeUnload); // Clean up the event listener
    };
  }, []);

  const submitHandler = (data) => {
    // Trigger validation when form is submitted
    if (reactHookFormData.trigger) {
      reactHookFormData.trigger();
    }
  };

  // Trigger validation when all required fields are filled to ensure buttons work
  useEffect(() => {
    const hasAllRequiredFields = 
      (formdata.firstName || formdata.lastName) && 
      formdata.phone && 
      formdata.email && 
      formdata.option;
    
    if (hasAllRequiredFields && reactHookFormData.trigger) {
      // Trigger validation to update the validation state
      reactHookFormData.trigger();
    }
  }, [formdata.firstName, formdata.lastName, formdata.phone, formdata.email, formdata.option, reactHookFormData.trigger]);

  useEffect(() => {
    setVerificationCode("");
  }, [emailVerificationId, formdata.email, isEmailVerified]);

  // Watch form values and update formdata
  useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      if (type === "change" && name) {
        setFormData((prev) => ({
          ...prev,
          [name]: value[name],
        }));
        
        // Trigger validation when any field changes
        // if (reactHookFormData.trigger) {
        //   reactHookFormData.trigger();
        // }
      }
    });
    
    return () => subscription.unsubscribe();
  // }, [watch, setFormData, reactHookFormData]);
  }, [watch, setFormData]);

  useEffect(() => {
    menuOption.forEach((m) => {
      m.active = false;
    });
  }, []);

  return (
    <div className="quote-colum rd-quote-w-full quote-scroller-hide md:rd-quote-w-[75%] quote-scroll-contact-details">
      <div className="rd-quote-mb-4">
        <form
          className="quote-contact-form"
          onSubmit={handleSubmit(submitHandler)}
        > 
          <div className="rd-quote-flex quote-direction-column rd-quote-flex-wrap lg:rd-quote-gap-x-5 xs:rd-quote-pl-3 xs:rd-quote-pr-3 lg:rd-quote-pl-0 lg:rd-quote-pr-6 xs:rd-quote-pt-3 md:rd-quote-pt-4">
            {/* for mobile screens */}
            {!isWebView && (
              <p className="quote-text2">
                How do you want your quote delivered?
                <span className="rd-quote-text-red-500 rd-quote-text-sm rd-quote-font-medium rd-quote-font-['SF Pro Text'] rd-quote-leading-tight">
                  *
                </span>
              </p>
            )}
            {!isWebView && (
              <div 
                className="rd-quote-mt-3 rd-quote-flex rd-quote-flex-col rd-quote-mb-4"
                style={{
                  '--checkbox-color': userSettings?.colourHex?.buttonAndBorderColor || '#ebebeb'
                }}
              >
                {menuOption.map((e, index) => {
                  const isSmsDisabled = e.value === "sms" &&
                    (countryDetails?.country !== "Australia" &&
                      countryDetails?.country !== "United States" &&
                      countryDetails?.country !== "Canada" &&
                      countryDetails?.country !== "United Kingdom");
                  const isPhoneDisabledValue = e.value === "phone" &&
                    (countryDetails?.country !== "Australia" &&
                      countryDetails?.country !== "United States" &&
                      countryDetails?.country !== "Canada");
                  const isDisabled = isSmsDisabled || isPhoneDisabledValue;
                  
                  return (
                    <div
                      key={e.name}
                      className={`rd-quote-flex rd-quote-items-center !rd-quote-gap-x-2
                        ${isDisabled
                          ? 'rd-quote-pointer-events-none rd-quote-opacity-50'
                          : ''}
                      `}
                    >
                      <input
                        type="checkbox"
                        value={e.value}
                        checked={e.active}
                        onChange={() => updateFields(index)}
                        disabled={isDisabled}
                      />
                      <icon className="rd-quote-text-gray-500">{e.icon}</icon>
                      <label>{e.name}</label>
                    </div>
                  );
                })}
              </div>
            )}

            {productCartDetail?.skipForOthers && progressState === 4 && (
              <label className="quote-text2">
                <span> Model </span>
                <span className="rd-quote-text-red-500 rd-quote-text-sm rd-quote-font-medium rd-quote-font-['SF Pro Text'] rd-quote-leading-tight">
                  *
                </span>
                <FormInput
                  register={register}
                  name="model"
                  placeholder="Enter Model"
                />
                {errors?.model?.message && (
                  <p className="rd-quote-text-red-500 rd-quote-mt-1">
                    {errors.model.message}
                  </p>
                )}
              </label>
            )}
            <label className="quote-text2">
              <span> First Name </span>
              {/* <span className="rd-quote-text-red-500 rd-quote-text-sm rd-quote-font-medium rd-quote-font-['SF Pro Text'] rd-quote-leading-tight">
                *
              </span> */}

              <FormInput
                register={register}
                name="firstName"
                placeholder="Enter First Name"
              />

              {/* {errors?.firstName?.message && (
                <p className="rd-quote-text-red-500 rd-quote-mt-1">
                  {errors.firstName.message}
                </p>
              )} */}
            </label>

            <label className="quote-text2">
              <span> Last Name </span>
              {/* <span className="rd-quote-text-red-500 rd-quote-text-sm rd-quote-font-medium rd-quote-font-['SF Pro Text'] rd-quote-leading-tight">
                *
              </span> */}

              <FormInput
                register={register}
                name="lastName"
                placeholder="Enter Last Name"
              />

              {/* {((isButtonClicked && !isWebView) || isWebView) && (
                <p className="rd-quote-text-red-500 rd-quote-mt-1">
                  {errors?.lastName?.message}
                </p>
              )} */}
            </label>

            {/* Show name validation error */}
            {errors?.nameRequired && (
              <p className="rd-quote-text-red-500 rd-quote-mt-1 rd-quote-mb-2">
                {errors.nameRequired.message}
              </p>
            )}

            <label className="quote-text2 quote-instant-form-width">
              <span> Phone </span>
              <span className="rd-quote-text-red-500 rd-quote-text-sm rd-quote-font-medium rd-quote-font-['SF Pro Text'] rd-quote-leading-tight">
                *
              </span>

              <Controller
                control={control}
                name="phone"
                render={({ field: { onChange, value } }) => (
                  <PhoneInput
                    international
                    defaultCountry={countryDetails?.country_code}
                    value={value}
                    onChange={(phoneValue) => {
                      onChange(phoneValue);
                      setFormData(prev => ({
                        ...prev,
                        phone: phoneValue
                      }));
                    }}
                    countrySelectProps={{
                      tabIndex: -1,
                      style: {
                        pointerEvents: 'none',
                        cursor: 'default',
                        userSelect: 'none'
                      }
                    }}
                    countryCallingCodeEditable={false}
                    className="rd-quote-mt-2 quote-border-styling phone-field-width rd-quote-py-2 rd-quote-pl-3 rd-quote-font-normal md:rd-quote-mt-2 rd-quote-rounded-md focus:rd-quote-outline-none rd-quote-ring-0 focus:rd-quote-border-none focus:rd-quote-ring-0 rd-quote-placeholder-gray-400 rd-quote-text-gray-700 rd-quote-text-sm rd-quote-w-full rd-quote-h-[40px]"
                  />
                )}
              />

              {errors?.phone?.message && (
                <p className="rd-quote-text-red-500 rd-quote-mt-1">
                  {errors.phone.message}
                </p>
              )}
            </label>

            <label className="quote-text2 quote-margin-top-mid-large-screen">
              <span> Email </span>
              <span className="rd-quote-text-red-500 rd-quote-text-sm rd-quote-font-medium rd-quote-font-['SF Pro Text'] rd-quote-leading-tight">
                *
              </span>

              <FormInput
                register={register}
                name="email"
                placeholder="Enter Email"
                type="email"
              />

              {errors?.email?.message && (
                <p className="rd-quote-text-red-500 rd-quote-mt-1">
                  {errors.email.message}
                </p>
              )}
            </label>

            {/* Email verification button - sits inline in the flex row next to Email */}
            {userSettings?.enableEmailValidation && (
              <div className="email-verify-btn-wrapper">
                {!isEmailVerified ? (
                  <button
                    type="button"
                    onClick={handleSendVerificationCode}
                    disabled={emailVerificationPending}
                    style={{
                      backgroundColor: emailVerificationPending
                        ? '#e5e7eb'
                        : (userSettings?.colourHex?.buttonAndBorderColor || '#4A90D9'),
                      color: emailVerificationPending ? '#9ca3af' : '#ffffff',
                    }}
                    className="email-verify-btn rd-quote-rounded-md rd-quote-text-sm rd-quote-font-medium"
                  >
                    {emailVerificationPending
                      ? "Sending..."
                      : emailVerificationId
                        ? "Resend Code"
                        : "Verify Email"}
                  </button>
                ) : (
                  <span className="email-verified-badge">
                    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm3.54 6.29L7.29 10.54a.75.75 0 01-1.06 0L4.46 8.77a.75.75 0 111.06-1.06l1.24 1.24 3.72-3.72a.75.75 0 111.06 1.06z" fill="#16a34a"/>
                    </svg>
                    Verified
                  </span>
                )}
              </div>
            )}
          </div>

          {/* Verification code entry - below the form fields row */}
          {userSettings?.enableEmailValidation && !isEmailVerified && emailVerificationId && (
            <div className="email-verify-code-section xs:rd-quote-pl-3 xs:rd-quote-pr-3 lg:rd-quote-pl-0 lg:rd-quote-pr-6">
              <div className="email-verify-code-row">
                <input
                  type="text"
                  inputMode="numeric"
                  maxLength={6}
                  value={verificationCode}
                  onChange={(event) => setVerificationCode(event.target.value.replace(/\D/g, ''))}
                  placeholder="Enter 6-digit code"
                  className="email-verify-code-input rd-quote-border rd-quote-border-gray-300 rd-quote-py-2 rd-quote-pl-3 rd-quote-font-normal rd-quote-rounded-md rd-quote-shadow-sm focus:rd-quote-outline-none rd-quote-ring-0 rd-quote-placeholder-gray-400 rd-quote-text-gray-700 rd-quote-text-sm"
                  style={{ letterSpacing: '3px', fontWeight: '600' }}
                />
                <button
                  type="button"
                  onClick={handleVerifyCode}
                  disabled={emailVerificationPending || !verificationCode}
                  style={{
                    backgroundColor: (emailVerificationPending || !verificationCode)
                      ? '#e5e7eb'
                      : (userSettings?.colourHex?.buttonAndBorderColor || '#4A90D9'),
                    color: (emailVerificationPending || !verificationCode) ? '#9ca3af' : '#ffffff',
                  }}
                  className="email-verify-btn rd-quote-rounded-md rd-quote-text-sm rd-quote-font-medium"
                >
                  {emailVerificationPending ? "Verifying..." : "Verify Code"}
                </button>
              </div>
              <p className="rd-quote-text-xs rd-quote-text-gray-400" style={{ marginTop: '4px' }}>
                A 6-digit code has been sent to your email. It expires in 5 minutes.
              </p>
            </div>
          )}

          {/* Verification error */}
          {userSettings?.enableEmailValidation && emailVerificationError && (
            <p className="rd-quote-text-red-500 rd-quote-text-sm xs:rd-quote-pl-3 xs:rd-quote-pr-3 lg:rd-quote-pl-0 lg:rd-quote-pr-6" style={{ marginTop: '4px' }}>
              {emailVerificationError}
            </p>
          )}

          <label className="quote-colum rd-quote-text-gray-700 rd-quote-font-medium rd-quote-text-[16px] lg:rd-quote-mt-2 xs:rd-quote-pl-3 xs:rd-quote-pr-3 lg:rd-quote-pl-0 lg:rd-quote-pr-6">
            <span> Notes </span>
            <textarea
              placeholder="Describe the issue you are facing with your device"
              name="notes"
              {...register("notes")}
              className="rd-quote-border rd-quote-py-2 rd-quote-pl-3 rd-quote-font-normal rd-quote-mt-2 rd-quote-border-gray-300 rd-quote-rounded-md rd-quote-shadow  focus:rd-quote-outline-none rd-quote-ring-0 focus:rd-quote-ring-0 rd-quote-placeholder-gray-400 rd-quote-text-gray-700 rd-quote-text-sm rd-quote-w-full rd-quote-mr-1"
            />
          </label>

          {/* for screens (tablet and laptop) */}
          {isWebView && (
            <p className="quote-text2 rd-quote-mt-5 rd-quote-pl-0 rd-quote-pr-6">
              How would you like us to share the update?
              <span className="rd-quote-ml-0.5 rd-quote-text-red-500 rd-quote-text-sm rd-quote-font-medium rd-quote-font-['SF Pro Text'] rd-quote-leading-tight">
                *
              </span>
            </p>
          )}
          {isWebView && (
            <div className="lg:rd-quote-pr-6 lg:rd-quote-pb-6 rd-quote-grid rd-quote-grid-cols-1 md:rd-quote-grid-cols-3 md:rd-quote-grid-flow-col rd-quote-gap-4 quote-alignment-center quote-card-grid md:rd-quote-mt-3">
              {menuOption.map((p, index) => (
                <Card
                  key={p.id}
                  product={p}
                  Icon={p.icon}
                  index={index}
                  filteredProducts={updateStatus}
                />
              ))}
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default ContactDeatils;